export const Payroll = 'Payroll/';

export const PayrollTypes = Payroll + 'PayrollTypes';
export const Sage300PeopleAuthTypes = Payroll + 'Sage300PeopleAuthTypes';
export const SavePayroll = Payroll + 'SavePayroll';
export const GetAllConnectedPayrolls = Payroll + 'GetAllConnectedPayrolls/';
export const GetConnectedPayroll = Payroll + 'GetConnectedPayroll/';
export const DisconnectPayroll = Payroll + 'DisconnectPayroll/';
export const TestPayrollConnection = Payroll + 'TestPayrollConnection';
export const HasConnectedPayroll = Payroll + 'HasConnectedPayroll/';
